import { render, staticRenderFns } from "./NavigationExpandedMenu.vue?vue&type=template&id=df86c7a8&scoped=true&"
import script from "./NavigationExpandedMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationExpandedMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationExpandedMenu.vue?vue&type=style&index=0&id=df86c7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df86c7a8",
  null
  
)

export default component.exports